__turbopack_context__.v({
  "logo": "style-module-scss-module__AwuIcq__logo",
});
